import { render, staticRenderFns } from "./PersonSelector.vue?vue&type=template&id=cdce2e42&scoped=true&"
import script from "./PersonSelector.vue?vue&type=script&lang=js&"
export * from "./PersonSelector.vue?vue&type=script&lang=js&"
import style0 from "./PersonSelector.vue?vue&type=style&index=0&id=cdce2e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdce2e42",
  null
  
)

export default component.exports